<script lang="ts">
    import { useComparisonContext } from '@shared/providers/comparison-context/ComparisonContext.browser';
    import type { TileImage, Variation } from '@shared/types/types.ts';
    import EekLabel from '@tile/components/eek/EekLabel.svelte';
    import ProductImage from '@tile/components/product-image/ProductImage.svelte';
    import type { ImageLoadingOptions } from '@tile/components/product-image/types';
    import PriceDispatcher from '@tilelist/layouts/dispatchers/price-dispatcher/PriceDispatcher.svelte';

    interface Props {
        variation: Variation;
        rule: string;
    }

    let { variation, rule }: Props = $props();

    function getMainImage(images: TileImage[]): TileImage {
        return (
            images.find((img) => img.role === 'HAUPT') ??
            images[0] ?? { id: '', alt: '', fallback: '', jpeg: '', webp: '' }
        );
    }

    const imageLoadingOptions: ImageLoadingOptions = {
        loading: 'lazy',
        fetchpriority: 'low',
    };

    const context = useComparisonContext();

    async function onDeleteButtonClicked() {
        await context.deselectVariation(variation.variationId);
    }
</script>

{#if variation}
    <div class="reptile_comparison_tile">
        <ProductImage
            variationId={variation.variationId || ''}
            image={getMainImage(variation.images)}
            detailPageLink={variation.detailPageLink}
            {imageLoadingOptions}
            aspectRatio="quad"
            size={{
                width: '88px',
                height: '88px',
            }}
        />
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <oc-icon-button-v3
            icon="delete"
            oc-aria-label="Produkt aus dem Vergleich entfernen"
            class="reptile_comparison_tile__button"
            onclick={onDeleteButtonClicked}
        ></oc-icon-button-v3>
        <div class="reptile_comparison_tile__content">
            <header>
                {#if variation.brand}
                    <p class="reptile_comparison_tile__brand oc-copy-100">{variation.brand}</p>
                {/if}
            </header>
            {#if variation.energyLabels}
                <EekLabel labels={variation.energyLabels} />
            {/if}
            <PriceDispatcher price={variation.price} variationId={variation.variationId} {rule} />
        </div>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile_comparison_tile {
        position: relative;

        &__brand {
            overflow: hidden;
            width: 88px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__button {
            position: absolute;
            top: 0;
            right: 0;
        }

        &__content {
            display: flex;
            flex-direction: column;
            gap: tokens.$oc-semantic-spacing-50;
            margin-top: tokens.$oc-semantic-spacing-100;
        }
    }
</style>
